import axios from 'axios'
import bar from '@/components/common/echarts/bar-color/index.vue'
import wordCloud from '@/components/common/echarts/wordCloud/index.vue'
import pie from '@/components/common/echarts/pie/index.vue'
export default {
  name: 'academic',
  components: { bar, wordCloud, pie },
  data () {
    return {
      // 研究资源loading
      loadingSpecial: false,
      // 热点主题loading
      loadingHost: false,
      // 分类统计loading
      loadingSort: false,
      // 高质量文件loading
      loadingQuality: false,
      // 默认id
      ywfldm: '00510905',
      // 上一个模块名字
      lastName: '',
      // 选中模块
      selectName: '',
      // 高质量文件列表
      specialList: []
    }
  },
  // 创建元素
  mounted () {
    // 获取研究资源统计
    this.getSpecialNumber()
    // 获取时代研究热点主题
    this.getSortHostNumber()
    // 获取分类统计
    this.getSortNumber()
    // 获取高质量文件
    this.getSpecialTen()
  },
  // 方法定义
  methods: {
    // 获取研究资源统计
    getSpecialNumber () {
      const self = this
      self.loadingSpecial = true
      axios.get('/yuhuamenhu/special/getSpecialNumber').then(json => {
        if (json.data.code === 200) {
          this.$refs.jsBar.update(json.data.data)
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingSpecial = false
      })
    },

    // 获取时代研究热点主题
    getSortHostNumber () {
      const self = this
      self.loadingHost = true
      axios.get('/yuhuamenhu/special/getSortHostNumber', {
        params: {
          ywfldm: this.ywfldm
        }
      }).then(json => {
        if (json.data.code === 200) {
          const hostList = []
          json.data.data.nvsms.forEach((item, index) => {
            hostList[index] = {}
            hostList[index].name = item
            hostList[index].value = Math.floor(Math.random() * 1000 + 1)
          })
          this.$refs.wordCloud.update(hostList)
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingHost = false
      })
    },

    // 点击热点词
    clickWord (param) {
      const detail = this.$router.resolve({
        path: '/moreSearch',
        query: {
          module: '专题研究',
          type: this.ywfldm,
          fieldName: '主题',
          queryName: param.name
        }
      })
      window.open(detail.href, '_blank')
    },

    // 获取分类统计
    getSortNumber () {
      const self = this
      self.loadingSort = true
      axios.get('/yuhuamenhu/special/getSortNumber', {
        params: {
          ywfldm: this.ywfldm
        }
      }).then(json => {
        if (json.data.code === 200) {
          this.$refs.jsPie.update(json.data.data)
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingSort = false
      })
    },

    // 点击进入饼图下一级
    clickPie (param) {
      if (this.ywfldm === param.ywfldm) {
        return
      }
      this.ywfldm = param.ywfldm
      // 获取时代研究热点主题
      this.getSortHostNumber()
      if (param.next === '1') {
        this.lastName = this.selectName
        this.selectName = param.name
        // 获取分类统计
        this.getSortNumber()
      }
    },

    // 点击返回最上级
    backIndex () {
      this.ywfldm = this.ywfldm.slice(0, -2)
      this.selectName = this.lastName
      // 获取时代研究热点主题
      this.getSortHostNumber()
      // 获取分类统计
      this.getSortNumber()
    },

    // 获取高质量文件
    getSpecialTen () {
      const self = this
      self.loadingQuality = true
      axios.get('/yuhuamenhu/special/getSpecialTen').then(json => {
        if (json.data.code === 200) {
          this.specialList = json.data.data
        } else {
          self.$message.warning(json.data.errorMessage)
        }
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        self.loadingQuality = false
      })
    },

    // 前往文献详情
    goDetail (param) {
      const yjztDetail = this.$router.resolve({
        path: '/yjztDetail',
        query: {
          name: param.name,
          from: param.from
        }
      })
      window.open(yjztDetail.href, '_blank')
    }
  }
}
